import { stringify } from 'query-string';
import type { AssetType } from '@atlassian/jira-asset-tracking-field-config/src/model/types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { FetchingStates, type AssetTypesResponse, type State } from '../types.tsx';

const DEFAULT_ASSET_TYPES_LIMIT = 50;

// Get asset types by recursively and consecutively requesting each page
// until last page has been requested and then return asset types
// @ts-expect-error - TS7023 - 'getAssetTypes' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const getAssetTypes = async ({
	assetTypes = [],
	isLastPage = false,
	start = 0,
	limit = DEFAULT_ASSET_TYPES_LIMIT,
}: {
	// @deprecated baseUrl is always '', remove it from your packages: go/baseurl-cleanup-jfe
	baseUrl?: string;
	assetTypes?: AssetType[];
	isLastPage?: boolean;
	start?: number;
	limit?: number;
}) => {
	if (isLastPage) return assetTypes;

	const data: AssetTypesResponse = await fetchJson(
		`/rest/assetapi/asset/type?${stringify({ start, limit })}`,
	);

	return getAssetTypes({
		assetTypes: [...assetTypes, ...data.values],
		isLastPage: data.isLastPage,
		start: start + limit,
		limit,
	});
};

const getAssetTypesAction =
	({
		forceRefetch = false,
		start = 0,
		limit = DEFAULT_ASSET_TYPES_LIMIT,
	}: {
		forceRefetch?: boolean;
		start?: number;
		limit?: number;
	}): Action<
		State,
		{
			// @deprecated baseUrl is always '', remove it from your packages: go/baseurl-cleanup-jfe
			baseUrl?: string;
		}
	> =>
	async ({ setState, getState }) => {
		const currentState = getState();
		if (
			(currentState.fetchingState === FetchingStates.LOADED && !forceRefetch) ||
			currentState.fetchingState === FetchingStates.LOADING
		)
			return;

		try {
			setState({
				fetchingState: FetchingStates.LOADING,
			});

			const assetTypes: AssetType[] = await getAssetTypes({ start, limit });

			setState({
				assetTypes,
				error: undefined,
				fetchingState: FetchingStates.LOADED,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				error,
				fetchingState: FetchingStates.FAILED,
			});
		}
	};

export default getAssetTypesAction;
